<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <MoreItemWrapper
    :icon="Info"
    :title="$t('views.more.info.toggle')"
  >
    <template #extra>
      <ToggleSwitch v-model="ui.showInfo" />
    </template>
  </MoreItemWrapper>
</template>

<script setup>
import { Info } from 'lucide-vue-next'
import { useUiStore } from '@/stores/ui.store'
import MoreItemWrapper from '@/components/settings/MoreItem.vue'
import ToggleSwitch from '@/components/ui/inputs/SwitchToggle.vue'

const ui = useUiStore()
</script>
